import React, {useContext} from 'react'
import {FaChevronLeft, FaPlus, FaTrash} from "react-icons/fa"
import {FormBuilderContext} from "../context/form-builder-context.jsx";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import InputCheckbox from "../../../../../components/input/input-checkbox.jsx";
import {Card} from "../../../../../components/card/card.jsx";
import InputFile from "../../../../../components/input/input-file.jsx";

const FormBuilderEditParameters = () => {
    const {structure, setStructure, selectItemId, handleSelectItem} = useContext(FormBuilderContext)

    const item = structure.find(i => i.id === selectItemId)

    const   handleItemInput = ({target: {id, value}}) => {
        if (id === "pdfWidth") {
            if (value > 12) value = 12
            if (value < 0) value = 0
        }

        setStructure(prev => prev.map(i => i.id === selectItemId ? {...i, [id]: value} : i))
    }

    const handleItemChecked = ({target: {id, checked}}) => {
        setStructure(prev => prev.map(i => i.id === selectItemId ? {...i, [id]: checked} : i))
    }

    const addOption = () => {
        setStructure(prev => prev.map(i => i.id === selectItemId ? {...i, options: [...i.options, ""]} : i))
    }

    const handleOption = (value, index) => {
        setStructure(prev =>
            prev.map(item => {
                if (item.id !== selectItemId) return item

                const options = item.options ?? []
                return {...item, options: options.map((option, i) => i === index ? value : option)}
            })
        )
    }

    const removeOption = (index) => {
        setStructure(prev =>
            prev.map(item => {
                if (item.id !== selectItemId) return item

                const options = item.options ?? []
                return {...item, options: options.filter((_, i) => i !== index)}
            })
        )
    }

    const handleFile = (file) => setStructure(prev => prev.map(i => i.id === selectItemId ? {...i, file, gedId: undefined} : i))

    return (
        <Card>
            <Card.Header className={"!justify-between"}>
                <Card.Title>{item?.type}</Card.Title>

                <span className="cursor-pointer" onClick={() => handleSelectItem(null)}>
                    <FaChevronLeft />
                </span>

            </Card.Header>
            <Card.Body className="overflow-auto max-h-[calc(100vh-253px)] space-y-4">
                {
                    item?.type && ["intext", "title", "subtitle"].includes(item?.type) ?
                        <>
                            <InputTextarea
                                value={item?.label ?? ""}
                                id="label"
                                label="Label"
                                onChange={handleItemInput}
                            />

                            {
                                item.type === "intext" &&
                                <em><small>Digite <b>':input'</b> aonde deseja ter um campo de input. <br/>Exemplo: Eu :input, portador do RG :input...</small></em>
                            }
                        </>
                        :
                        <InputForm
                            value={item?.label ?? ""}
                            id="label"
                            label="Label"
                            onInput={handleItemInput}
                        />
                }

                {
                    item && Object.hasOwn(item, "pdfWidth") &&
                    <InputForm
                        value={item?.pdfWidth ?? 12}
                        id="pdfWidth"
                        label="pdfWidth"
                        type={"number"}
                        min={0}
                        max={12}
                        onInput={handleItemInput}
                    />
                }

                {
                    item?.type && ["input", "textarea"].includes(item.type) &&
                    <>
                        <InputForm
                            value={item?.referenceId ?? ""}
                            id="referenceId"
                            label="referenceId"
                            onInput={handleItemInput}
                        />

                        <small>
                            Informe a key correspondente ao campo.
                            <br />Exemplo simples - campo: 'Nome' referenceId: 'name'
                            <br />Exemplo dentro de objeto/array - campo: 'Nome do agressor' referenceId: 'aggressors.name'
                        </small>
                    </>
                }

                {
                    item && Object.hasOwn(item, "required") &&
                    <InputCheckbox
                        id="required"
                        label="Required"
                        checked={item.required}
                        onChange={handleItemChecked}
                    />
                }

                {
                    item && Object.hasOwn(item, "options") &&
                    <Card>
                        <Card.Body id="options-idk" className="!p-0">
                            {
                                item.options.map((option, i) => (
                                    <div className="option-item" key={"option-item-" + i}>
                                        <input
                                            className={"truncate text-[13px]"}
                                            id={item.id + "-" + i}
                                            value={option}
                                            placeholder={"item-" + i}
                                            onChange={({target: {value}}) => handleOption(value, i)}
                                            onKeyDown={({key}) => { if (key === "Enter") addOption() } }
                                            autoFocus={true}
                                        />
                                        <button onClick={() => removeOption(i)}>
                                            <FaTrash />
                                        </button>
                                    </div>
                                ))
                            }
                        </Card.Body>
                        <Card.Footer className={"bg-white !px-0 !py-0 text-center"}>
                            <div className="flex gap-2 justify-center cursor-pointer w-full text-[13px] items-center" onClick={addOption}>
                                <FaPlus /> Adicionar opção
                            </div>
                        </Card.Footer>
                    </Card>
                }

                {
                    item?.type && ["image"].includes(item.type) &&
                    <InputFile
                        file={item?.gedId ? {attachId: item?.gedId, type: "image/jpg"} : item?.file}
                        setFile={handleFile}
                        removeFile={() => handleFile(undefined)}
                        accept={"image/*"}
                    />
                }
            </Card.Body>
        </Card>
    )
}

export default FormBuilderEditParameters